export const fetchData = async (url, setData) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch data from ${url}`);
  }

  const result = await response.json();

  if (typeof setData === 'function') {
    setData(result);
  }

  return result;
};
